import { cloneDeep, findIndex } from 'lodash'
import {
  REQUEST_GET,
  REQUEST_POST,
  REQUEST_PUT,
  REQUEST_DELETE,
} from './API_Request'
import { AlertMessage, errorMessage } from '@/plugins/common'
import { GLOBAL_MESSAGE } from '@/plugins/message'

export const state = {
  categories: {
    data: [],
    total: 0,
  },
}

export const mutations = {
  async GET_CATEGORIES(state, data) {
    data.toggleLoading()
    try {
      const res = await REQUEST_GET('/cms/categories', data.form)
      state.categories.data = res?.data?.data || []
      state.categories.total = res?.data?.total || 0
      data.toggleLoading()
      return state
    } catch (e) {
      data.toggleLoading()
      const error = errorMessage(e)
      return error
    }
  },
  async CREATE_CATEGORY(state, data) {
    data.toggleLoading()
    try {
      const res = await REQUEST_POST('/cms/categories', data.form)
      state.categories.data.push(res.data)
      state.categories.total++
      data.toggleLoading()

      // Alert
      const alert = new AlertMessage(
        GLOBAL_MESSAGE.CREATE.SUCCESS,
        'ok',
        'success'
      )
      data.toggleAlert(alert)
      return state
    } catch (e) {
      data.toggleLoading()
      const error = errorMessage(e)

      // Alert
      const alert = new AlertMessage(
        GLOBAL_MESSAGE.CREATE.ERROR,
        'error',
        'error'
      )
      data.toggleAlert(alert)
      return error
    }
  },
  async EDIT_CATEGORY(state, data) {
    data.toggleLoading()
    try {
      const res = await REQUEST_PUT(
        `/cms/categories/${data.form?.id}`,
        data.form
      )

      const categories = cloneDeep(state.categories.data)
      const index = findIndex(categories, { id: res?.data?.id })

      categories[index] = res.data
      state.categories = {
        ...state.categories,
        data: categories,
      }
      data.toggleLoading()

      // Alert
      const alert = new AlertMessage(
        GLOBAL_MESSAGE.EDIT.SUCCESS,
        'ok',
        'success'
      )
      data.toggleAlert(alert)
      return state
    } catch (e) {
      data.toggleLoading()
      const error = errorMessage(e)

      // Alert
      const alert = new AlertMessage(GLOBAL_MESSAGE.EDIT.ERROR, 'error', 'error')
      data.toggleAlert(alert)
      return error
    }
  },
  async DELETE_CATEGORY(state, data) {
    data.toggleLoading()
    try {
      await REQUEST_DELETE(`/cms/categories/${data.form?.id}`)

      const categories = cloneDeep(state.categories.data)
      const index = findIndex(categories, { id: data.form?.id })

      categories.splice(index, 1)
      state.categories = {
        ...state.categories,
        data: categories,
      }
      data.toggleLoading()

      // Alert
      const alert = new AlertMessage(
        GLOBAL_MESSAGE.DELETE.SUCCESS,
        'ok',
        'success'
      )
      data.toggleAlert(alert)
      return state
    } catch (e) {
      data.toggleLoading()
      const error = errorMessage(e)

      // Alert
      const alert = new AlertMessage(
        GLOBAL_MESSAGE.DELETE.ERROR,
        'error',
        'error'
      )
      data.toggleAlert(alert)
      return error
    }
  },
}

export const actions = {
  getCategories(context, form) {
    const toggleLoading = () => context.dispatch('toggleLoading')
    const toggleAlert = (alertForm) =>
      context.dispatch('toggleAlertMessage', alertForm)
    context.commit('GET_CATEGORIES', { toggleLoading, form, toggleAlert })
  },
  createCategory(context, form) {
    const toggleLoading = () => context.dispatch('toggleLoading')
    const toggleAlert = (alertForm) =>
      context.dispatch('toggleAlertMessage', alertForm)
    context.commit('CREATE_CATEGORY', { toggleLoading, form, toggleAlert })
  },
  editCategory(context, form) {
    const toggleLoading = () => context.dispatch('toggleLoading')
    const toggleAlert = (alertForm) =>
      context.dispatch('toggleAlertMessage', alertForm)
    context.commit('EDIT_CATEGORY', { toggleLoading, form, toggleAlert })
  },
  deleteCategory(context, form) {
    const toggleLoading = () => context.dispatch('toggleLoading')
    const toggleAlert = (alertForm) =>
      context.dispatch('toggleAlertMessage', alertForm)
    context.commit('DELETE_CATEGORY', { toggleLoading, form, toggleAlert })
  },
}

export const getters = {
  // Add Logic Before Computed
  categories(state) {
    // eslint-disable-line
    return state.categories
  },
}

export const categories = {
  state,
  mutations,
  actions,
  getters,
}
